@if (client$ | async; as client) {
  <zah-upsert-client
    [client]="client"
    [diensten]="diensten$ | async"
    [zones]="zones$ | async"
    okLabel="Bewaar"
    (meldingenClicked)="navigateToMeldingen($event)"
    (prestatiesClicked)="navigateToPrestaties($event)"
    (archiveClicked)="archiveClient($event)"
    (unarchiveClicked)="unarchiveClient($event)"
    (editDienstenClicked)="onEditDienstenClicked(client)"
    (cancelClicked)="onCancelClicked(client)"
    (okClicked)="onEditClicked($event)">
  </zah-upsert-client>
}
